export const dialog = (theme) => ({
    modal: {},
    modalContainer: {
        width: "100%",
        height: "100%",
    },
    modalHeader: {
        top: 0,
        left: "auto",
        right: 0,
        position: "sticky",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: 1100,
        boxSizing: "border-box",
        flexShrink: 0,
        borderBottom: `1px solid ${theme.customPalette.neutralGy05}`,
        background: "white",
        padding: theme.spacing(3, 2, 3, 2),
    },
    modalFooter: {
        zIndex: 1100,
        bottom: 0,
        left: "auto",
        right: 0,
        position: "sticky",
        width: "100%",
        background: "white",
        [theme.breakpoints.down("sm")]: {
            borderTop: `1px solid ${theme.customPalette.neutralGy05}`,
        },
    },
    modalBody: {
        overflowY: "auto",
    },
});
